module.exports = __webpack_public_path__ + "static/bitmap-francesco-muzzi-cdd3d809595f3a9c2aaaffe349408a22.png";